import { useEffect } from 'react';

// 扩展 Window 接口以包含全局变量
declare global {
  interface Window {
    gptbaseConfig?: {
      chatbotId: string;
      embedSuccess?: boolean;
    };
    widgetAutoOpenUrls?: {
      checked: boolean;
      urls: string[];
    };
  }
}

export const useWidgetScript = (scriptContent: string, shouldInsert = true) => {
  useEffect(() => {
    if (!shouldInsert || !scriptContent) return;

    // 创建一个临时的 div 元素来解析 HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = scriptContent;

    // 获取所有的 script 元素
    const scripts = tempDiv.getElementsByTagName('script');
    const addedScripts: HTMLScriptElement[] = [];

    // 遍历并执行/插入每个脚本
    Array.from(scripts).forEach((script) => {
      const newScript = document.createElement('script');

      // 复制脚本的所有属性
      Array.from(script.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });

      // 如果是内联脚本，复制其内容
      if (!script.src) {
        newScript.textContent = script.textContent;
      }

      // 添加唯一标识符用于清理
      newScript.setAttribute('data-widget-script', 'true');

      // 将新脚本添加到文档中
      document.body.appendChild(newScript);
      addedScripts.push(newScript);
    });

    // 清理函数
    return () => {
      // 移除所有通过这个 effect 添加的脚本
      addedScripts.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });

      // 额外清理：移除所有带有 data-widget-script 属性的脚本
      const remainingScripts = document.querySelectorAll('script[data-widget-script="true"]');
      remainingScripts.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });

      // 清理 plugin.js 创建的 DOM 元素
      const elementsToRemove = ['gptbase-bubble-button', 'gptbase-message-bubbles', 'gptbase-bubble-window'];

      elementsToRemove.forEach((elementId) => {
        const element = document.getElementById(elementId);
        if (element && element.parentNode) {
          element.parentNode.removeChild(element);
        }
      });

      // 清理全局配置和变量
      if (window.gptbaseConfig) {
        delete window.gptbaseConfig;
      }

      if (window.widgetAutoOpenUrls) {
        delete window.widgetAutoOpenUrls;
      }

      if ((window as any).hismobile_phone_list) {
        delete (window as any).hismobile_phone_list;
      }
    };
  }, [scriptContent, shouldInsert]);
};
